import { render, staticRenderFns } from "./ExternalIntegration.vue?vue&type=template&id=589bf0d8&scoped=true"
import script from "./ExternalIntegration.vue?vue&type=script&lang=js"
export * from "./ExternalIntegration.vue?vue&type=script&lang=js"
import style0 from "./ExternalIntegration.vue?vue&type=style&index=0&id=589bf0d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589bf0d8",
  null
  
)

export default component.exports